export const idCMI = '5a5e3f7e0bd5677324737244';
